module.exports = __webpack_public_path__ + "img/motoboy-02.0bab6a15.svg";